//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from './Tooltip.vue'
export default {
  components:{
      'tooltip':Tooltip
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    position: {
      type:String,
      default:'center',
      required:true
    }
  },
  data: () => ({
    dialog: false,
    rules: {
      description: [
        (val) => (val || "").length > 0 || "This field is required",
      ],
    },
    entry: {
      description: "",
      value: "0.00",
      category: "",
    },
    operationType: {
      color: "grey",
      text: "Undefined",
    },
  }),
  methods: {
    save() {
      this.dialog = false;
      this.$emit("entryAdded", this.entry);
    },
  },
  watch: {
    "entry.value": function (value) {
      const defaultOperationType = {
        color: "grey",
        text: "Undefined",
      };
      const expenseOperationType = {
        color: "#b0364a",
        text: "Expense",
      };
      const earningOperationType = {
        color: "#36b09a",
        text: "Earning",
      };

      if (
        value == "0.00" ||
        value == null ||
        value == undefined ||
        value == 0
      ) {
        this.operationType = defaultOperationType;
        return;
      }
      const parsedValue = parseFloat(value);
      return parsedValue > 0
        ? (this.operationType = earningOperationType)
        : (this.operationType = expenseOperationType);
    },
  },
};
